module.exports = __webpack_public_path__ + "media/images/lizard-6390ebf3ac9cfb16e1e9667d88462b2a.png";